import { createContext } from "react";

const EntryBrandingContext = createContext({ active: false, register: () => () => {} });
export default EntryBrandingContext;
